<template>
  <vs-col vs-w="12" class="mt-2">
    <vs-row vs-w="12">
      <label for="" class="vs-input--label">{{ label }}</label>
    </vs-row>

    <vs-row vs-w="12" v-if="limit">
      <vs-input
        label="Min (%)"
        class="inputx w-24"
        type="number"
        v-model="minPercentage"
        :danger="!isMinPercentageValid()"
        danger-text="Not valid"
      />
      <div class="mx-4 mt-8">-</div>

      <vs-input
        label="Max (%)"
        class="inputx w-24"
        type="number"
        v-model="maxPercentage"
        :danger="!isMaxPercentageValid()"
        danger-text="Not valid"
      />

      <vs-button
        class="mt-5 ml-4"
        @click="handleRemoveClick"
        type="filled"
        color="danger"
        icon="remove"
      />
    </vs-row>

    <vs-row vs-w="12" v-if="!limit" vs-align="center">
      <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
        <span class="ml-2 mr-4">No Limit</span>
      </vs-col>

      <vs-col vs-lg="6" vs-sm="7" vs-xs="12">
        <vs-button
          @click="handleAddClick"
          type="filled"
          color="success"
          icon="add"
        ></vs-button>
      </vs-col>
    </vs-row>
  </vs-col>
</template>

<script>
import * as _ from "lodash";

export default {
  props: {
    limit: {
      type: Object,
    },
    limitType: {
      type: Number,
    },
    label: {
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {
    minPercentage: {
      get() {
        if (this.limit === null || this.limit === undefined) return;
        return this.limit.minPercentage;
      },
      set(value) {
        const intValue = Number.parseInt(value);
        if (isNaN(intValue)) return;
        this.limit.minPercentage = intValue;
        if (this.limit.minPercentage < 0) this.limit.minPercentage = 0;
      },
    },
    maxPercentage: {
      get() {
        if (this.limit === null || this.limit === undefined) return;
        return this.limit.maxPercentage;
      },
      set(value) {
        const intValue = Number.parseInt(value);
        if (isNaN(intValue)) return;
        this.limit.maxPercentage = intValue;
        if (this.limit.maxPercentage < 0) this.limit.maxPercentage = 0;
      },
    },
  },
  methods: {
    handleRemoveClick() {
      setTimeout(() => {
        this.$emit("limit-removed", this.limitType);
      }, 10);
    },
    handleAddClick() {
      setTimeout(() => {
        this.$emit("limit-added", this.limitType);
      }, 10);
    },
    isMinPercentageValid() {
      const isValid =
        this.limit.minPercentage >= 0 &&
        this.limit.maxPercentage >= this.limit.minPercentage;
      return isValid;
    },
    isMaxPercentageValid() {
      const isValid =
        this.limit.maxPercentage >= 0 &&
        this.limit.maxPercentage >= this.limit.minPercentage;
      return isValid;
    },
  },
};
</script>
